import React from 'react'
import { Container, ItemData } from './styled'
import { useSelector } from 'react-redux'
import { translations } from '../../../../../utils/language'
import { DatePicker } from '../../../../../components/ui/date-picker'

const FiltersOrders = (props) => {
    const language = useSelector((state) => state.reducerLanguage);

    return (
        <Container>
            <label className="text-sm font-medium text-gray-600 whitespace-nowrap">
                {translations["sales-desde"][language.data]}
            </label>
            <ItemData>
                <DatePicker
                    value={props.dateInicioFilter}
                    onChange={props.setDateInicioFilter}
                    placeholder="dd/mm/aaaa"
                />
            </ItemData>

            <label className="text-sm font-medium text-gray-600 whitespace-nowrap">
                {translations["sales-ate"][language.data]}
            </label>
            <ItemData>
                <DatePicker
                    value={props.dateFimFilter}
                    onChange={props.setDateFimFilter}
                    placeholder="dd/mm/aaaa"
                />
            </ItemData>
        </Container>
    )
}

export default FiltersOrders

